import React from 'react'
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { Icon } from '@components/base'

export const NoraHomeWalkthroughCloseButton = ({
  onPress,
  style,
  testID = 'nora-home-walkthrough-screen-close',
}: {
  onPress: () => void
  style?: StyleProp<ViewStyle>
  testID?: string
}) => {
  const theme = useTheme()

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      accessibilityLabel="Close Nora tutorial"
      hitSlop={6}
      testID={testID}
      style={[styles.closeButton, style]}
      onPress={onPress}
    >
      <Icon name="x" size={16} color={theme['theme.solid.white']} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  closeButton: {
    position: 'absolute',
    top: 50,
    left: 24,
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    zIndex: 3,
  },
})
